var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_1727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5762 21.4746C10.6445 21.4551 10.7031 21.4258 10.7715 21.3867L18.418 17.0312C19.3262 16.5137 19.8145 15.9863 19.8145 14.5703V6.96289C19.8145 6.66992 19.7949 6.43555 19.7363 6.2207L10.5762 11.4551V21.4746ZM9.23828 21.4746V11.4551L0.078125 6.2207C0.0195312 6.43555 0 6.66992 0 6.96289V14.5703C0 15.9863 0.498047 16.5137 1.39648 17.0312L9.05273 21.3867C9.11133 21.4258 9.16992 21.4551 9.23828 21.4746ZM9.91211 10.2832L14.082 7.91992L4.83398 2.63672L1.25 4.67773C1.03516 4.79492 0.859375 4.91211 0.703125 5.05859L9.91211 10.2832ZM15.4395 7.14844L19.1113 5.05859C18.9648 4.91211 18.7891 4.79492 18.5742 4.67773L11.6797 0.751953C11.084 0.410156 10.4883 0.224609 9.91211 0.224609C9.32617 0.224609 8.73047 0.410156 8.13477 0.751953L6.15234 1.875L15.4395 7.14844Z",
    fill: "#F2B950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_1727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1758,
    height: 21.4746,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.5b65ea4726deacaaec74e2ca7f430041.svg";
export { ForwardRef as ReactComponent };